import { motion } from "framer-motion";

const clients = [
  {
    title: "Concerts & Music Festivals",
    desc: "Multi-day coverage, weather-resilient crews, and teams that scale from 5,000 to 80,000+ crowds.",
    img: "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxjb25jZXJ0JTIwY3Jvd2QlMjBmZXN0aXZhbHxlbnwwfHx8fDE3ODg5MjU2MTV8MA&ixlib=rb-4.1.0&q=85",
    tag: "5K–80K+ attendees",
  },
  {
    title: "Pro Sports Stadiums & Arenas",
    desc: "Strict gate synchronization, season-long roster consistency, and VIP press box service.",
    img: "https://images.unsplash.com/photo-1522778119026-d647f0596c20?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxzdGFkaXVtJTIwc3BvcnRzJTIwZXZlbnR8ZW58MHx8fHwxNzg4OTI1NjE1fDA&ixlib=rb-4.1.0&q=85",
    tag: "Season contracts",
  },
  {
    title: "Brand Activations & Pop-Ups",
    desc: "Polished, camera-ready ambassadors who immerse in your brand before day one.",
    img: "https://images.unsplash.com/photo-1758526348403-b729c700d675?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxldmVudCUyMHN0YWZmJTIwdGVhbSUyMGhvc3BpdGFsaXR5fGVufDB8fHx8MTc4ODkyNTYyM3ww&ixlib=rb-4.1.0&q=85",
    tag: "Sponsor-ready",
  },
  {
    title: "Conventions & Mega Expos",
    desc: "Badge management, keynote room monitoring, and registration desk crews at scale.",
    img: "https://images.unsplash.com/photo-1471295253337-3ceaaedca402?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxzdGFkaXVtJTIwc3BvcnRzJTIwZXZlbnR8ZW58MHx8fHwxNzg4OTI1NjE1fDA&ixlib=rb-4.1.0&q=85",
    tag: "Multi-hall ops",
  },
];

export default function WhoWeServeSection() {
  return (
    <section id="who-we-serve" className="py-20 sm:py-28 bg-[#0F111A] border-y border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="text-xs uppercase tracking-[0.2em] font-mono-tactical font-semibold text-sky-400">
            Who We Serve
          </p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold uppercase tracking-tight text-white">
            Built for the Biggest Stages
          </h2>
        </motion.div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {clients.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`serve-card-${i + 1}`}
              className="group bg-[#131622] border border-white/10 rounded-md overflow-hidden transition-all duration-300 hover:border-sky-500/40 hover:-translate-y-1"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute bottom-3 left-3 font-mono-tactical text-[10px] uppercase tracking-widest bg-[#090A0F]/80 backdrop-blur text-sky-400 border border-sky-500/30 rounded-full px-3 py-1">
                  {c.tag}
                </span>
              </div>
              <div className="p-5">
                <h3 className="font-display text-lg font-bold text-white">
                  {c.title}
                </h3>
                <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                  {c.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
